import _ from "lodash";

export const DATA_LIMIT = 10;

export const MASTER_DATA_DASHBOARD_TABS_LIST = [
    {key: 'dimension', label: 'Dimension'},
];

export const DEFAULT_MASTER_DATA_DASHBOARD_TAB = {key: 'dimension', label: 'Dimension'};


export const MASTER_DATA_INFO_IDS_LIST = {
    DIMENSIONS: "dimensions",
};
